export const EXPLORE_PREVIEW_INFO_PROPS = {
    imageBorderRadius: '16px',
    horizontalPadding: 16,
    speakerRowMarginBottom: 12,
    bodyPaddingTop: 12,
    bodyPaddingBottom: 4,
};

export const CHAT_THREAD_PREVIEW_INFO_PROPS = {
    ...EXPLORE_PREVIEW_INFO_PROPS,
    showTopicLabel: false,
    className: 'previewInfoVerticalListCard',
    horizontalPadding: 0,
    bodyPaddingBottom: 0,
};
